var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"root"},[_c('router-view'),_vm._v(" "),_c('notifications',{attrs:{"group":"main"}})],1),_vm._v(" "),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }